import { ApiSupportSelector } from "../../../helpers/apiSupport"
import { InitialState } from "../reducers"

export const Selector = {
    get: (state): InitialState => {
        return state.inventory.stockDocumentConfiguration
    },

    getListing: (state) => {
        return Selector.get(state).listing
    },

    isLoading: (state) => {
        return Selector.get(state).isLoading
    },

    getColorCodeAndName: (state) => {
        const {colorCode, name} = Selector.get(state)
        return {
            colorCode: colorCode,
            name: name,
        }
    },

    getIncludeContact: (state) => {
        return Selector.get(state).includeContact
    },

    getDefinition: (state) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {listing, ...definition} = Selector.get(state)
        return definition
    },

    getId: (state) => {
        return Selector.get(state).id
    },

    getStatuses: (state) => {
        const statuses = Selector.get(state).statuses
        return statuses?.map(s => {
            return {
                id: s.id,
                ...s.attributes,
            }
        }) ?? []
    },

    getTemplates: (state) => {
        const documentTemplates = Selector.get(state).documentTemplates?.map(t => {
            return {
                id: t.id,
                ...t.attributes,
            }
        }) ?? []

        const emailTemplates = Selector.get(state).emailTemplates?.map(t => {
            return {
                id: t.id,
                ...t.attributes,
            }
        }) ?? []

        return {
            documentTemplates: documentTemplates,
            emailTemplates: emailTemplates,
        }
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/selectors/selectors.ts